import React from 'react';
import loadable from '@loadable/component';

import { StructureNavigationProps } from 'modules/shared/types';
import { UnknownContent } from 'modules/shared/components';

export const ContentSelector: React.FC<StructureNavigationProps> = ({
    template,
    ...rest
}: StructureNavigationProps) => {
    switch (template) {
        case 'list-event': {
            const ListEvent = loadable(() =>
                import(/* webpackChunkName: "list-event-page" */ '../../../../pages/list-event/list-event-page'),
            );
            return <ListEvent {...rest} />;
        }
        default:
            return <UnknownContent />;
    }
};
